import React from 'react';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';

const Cover = ({fadeOut}) => {
    return (
        <Container className={`cover col-xxl-8 px-4 py-5 justify-content-center ${fadeOut ? 'fade-out' : ''}`}>
            <img src={require('../images/background-image.svg').default} alt='Accent' loading='lazy' className='accent-image' />
            <Row className='text-center flex-lg-row align-items-center justify-content-center g-5 py-5 cover-content'>
                <Col className='col-8 col-sm-6 col-lg-4  bg-transp'>
                    <img src={require('../images/Y4C LOGO.svg').default}
                        alt='Youth for change'
                        className='img-fluid mx-lg-auto bg-transp'
                        loading='lazy' />
                </Col>
                <Col className='col-lg-6 display-5 bg-transp'>
                        <h1 className='display-1 cover-text fw-bold bg-transp'>Youth<br/><span className='display-3 bg-transp'>for</span><br/>change</h1>
                        <p className='cover-lead-text fs-small fw-normal mt-3 bg-transp'>Associação</p>
                </Col>
            </Row>

                {/* <img className="logo" src={require('../images/Y4CLOGO2.svg').default} alt="Youth for change" />
                <div className="cover-text">
                    <p><span className="accent-y">Y</span>outh</p>
                    <p className="for"><span className="accent-f">f</span>or</p>
                    <p><span className="accent-c">c</span>hange</p>
                    <p id="association">Associação</p>
                </div> 
                */}

            </Container>
    );
};

export default Cover;